import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    modelValue: _ctx.modalShow,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.modalShow) = $event)),
    width: "1000"
  }, {
    default: _withCtx(() => [
      (_ctx.scenarioProcessingLog && _ctx.scenario && _ctx.model)
        ? (_openBlock(), _createBlock(_component_v_card, { key: 0 }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_title, { "primary-title": "" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("message.scenarioProcessingLog")) + " (" + _toDisplayString(_ctx.scenario.name) + ") (" + _toDisplayString(_ctx.$t("message.last100records")) + ") ", 1)
                ]),
                _: 1
              }),
              (_ctx.scenarioProcessingLog)
                ? (_openBlock(), _createBlock(_component_v_card_text, { key: 0 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_data_table, {
                        headers: _ctx.headers,
                        items: _ctx.scenarioProcessingLog,
                        "items-per-page": -1,
                        "hide-default-footer": ""
                      }, {
                        [`header.error`]: _withCtx(({ column }) => [
                          _createTextVNode(_toDisplayString(column.title) + " ", 1),
                          _createVNode(_component_v_icon, {
                            size: "x-small",
                            color: "grey",
                            title: _ctx.$t('message.ownerOnly')
                          }, {
                            default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                              _createTextVNode("mdi-lock-outline", -1)
                            ]))]),
                            _: 1
                          }, 8, ["title"])
                        ]),
                        [`item.scheduledDateTimeUtc`]: _withCtx(({ item }) => [
                          (item.scheduledDateTimeUtc != null)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_ctx.$filters.datetime(item.scheduledDateTimeUtc)) + " UTC", 1))
                            : _createCommentVNode("", true)
                        ]),
                        [`item.startedDateTimeUtc`]: _withCtx(({ item }) => [
                          (item.startedDateTimeUtc != null)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.$filters.datetime(item.startedDateTimeUtc)) + " UTC", 1))
                            : _createCommentVNode("", true)
                        ]),
                        [`item.isoLinesMissingDateTimeUtc`]: _withCtx(({ item }) => [
                          (item.isolinesMissingDateTimeUtc != null)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.$filters.datetime(item.isolinesMissingDateTimeUtc)) + " UTC", 1))
                            : _createCommentVNode("", true)
                        ]),
                        [`item.endedDateTimeUtc`]: _withCtx(({ item }) => [
                          (item.endedDateTimeUtc != null)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.$filters.datetime(item.endedDateTimeUtc)) + " UTC", 1))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1032, ["headers", "items"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_v_divider),
              _createVNode(_component_v_card_actions, null, {
                default: _withCtx(() => [
                  _cache[2] || (_cache[2] = _createElementVNode("div", { class: "flex-grow-1" }, null, -1)),
                  _createVNode(_component_v_btn, {
                    color: "primary",
                    variant: "text",
                    onClick: _ctx.close
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("message.close")), 1)
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["modelValue"]))
}